var swiper = new Swiper(".post-slider", {
  loop: true,
  slidesPerView: 1,
  autoHeight: true,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});